export const getDefuntoCompanyForTemplate = (defunto = {}) =>
  defunto?.company_pointer || defunto?.office_pointer?.company_pointer || null;

export const getDefuntoOfficeForTemplate = (defunto = {}) =>
  defunto?.office_pointer || null;

export const getEnrichedContextDefuntoCompanyOfficeAliases = (defunto = {}) => {
  if (!defunto || typeof defunto !== 'object') {
    return {};
  }

  const enriched = { ...defunto };
  const azienda = getDefuntoCompanyForTemplate(defunto);
  const sede = getDefuntoOfficeForTemplate(defunto);

  if (azienda) {
    enriched.azienda = azienda;
  }

  if (sede) {
    enriched.sede = sede;
  }

  return enriched;
};
